import * as yup from "yup";

export const GetStudentDataFormValidation = yup.object().shape({
    studentCode: yup.string()
    .required('Código do estudante é obrigatório')
  });